import React from 'react'
import styles from './Button.module.css'

const Button = ({ children, loading, ...props }) => {
  return (
    <button {...props} className={`${styles.button} ${styles.buttonWidth}`} disabled={loading.value}>
        {loading.value && (
            <i
              className="fa fa-refresh fa-spin"
              style={{ marginRight: '5px' }}
            />
        )}
      {children}
    </button>
  )
}

export default Button
